export const FILES = [
  { id: '123', mime_type: 'application/vnd.ms-excel', name: 'test_excel.xls' },
  { id: '123', mime_type: 'application/msword', name: 'test_word.doc' },
  { id: '123', mime_type: 'none', name: 'test_none.some' },
]
